export default __webpack_public_path__ + "static/media/regulatory--trams-only--g1.5a5684c6.png";